// extracted by mini-css-extract-plugin
export default {"QuantityBadge":"QuantityBadge-styles__QuantityBadge__ZkFga"};